// extracted by mini-css-extract-plugin
export default {"rotate":"RotateMessage_rotate__kXvp-","phone":"RotateMessage_phone__1y98p","message":"RotateMessage_message__goJHh"};